export const filter = {
  id : '',  
  name: '', 
  parent_department_id: '',
  created_at: '',
  updated_at: ''  
};
